import { ICampaignAttribution } from '~/utils/posthog/campaignAttribution';

/**
 * Extract campaign attribution from a URL query string. Branch deep links land
 * on the portal with their `utm_*` params appended to the URL, so reading the
 * query is sufficient on web (no Branch SDK like the mobile app).
 *
 * `document.referrer` is captured as the referring link. Returns null when
 * there is no campaign to attribute — a campaign alone is enough, matching the
 * mobile app (source/medium are optional).
 */
export const extractUtmParams = (search?: string): ICampaignAttribution | null => {
  const params = new URLSearchParams(search ?? '');

  const source = params.get('utm_source') || undefined;
  const campaign = params.get('utm_campaign') || undefined;
  const medium = params.get('utm_medium') || undefined;
  const content = params.get('utm_content') || undefined;
  const term = params.get('utm_term') || undefined;
  const referringLink =
    (typeof document !== 'undefined' && document.referrer) || undefined;

  if (!campaign) return null;

  return { source, campaign, medium, content, term, referringLink };
};
